import React from 'react';
import HealthandNutrition2025 from 'views/HealthandNutrition2025'

const AccountGeneralPage = () => {
  return <HealthandNutrition2025/>;
};

export default AccountGeneralPage;